import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/userActions';
import * as ordActionCreator from '../store/actions/orderActions';
import * as invActionCreator from '../store/actions/inventoryActions';
import {
  IonPage,
  IonButtons,
  IonMenuButton,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import {
  personOutline,
  documentTextOutline,
  fileTrayFullOutline,
  gridOutline,
} from 'ionicons/icons';

import Tab0 from './Tab0';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';

import AddItemContainer from '../Containers/AddItemContainer';
import EditItemContainer from '../Containers/EditItemContainer';
import ItemDetailsContainer from '../Containers/ItemDetailsContainer';

import AddOrderContainer from '../Containers/AddOrderContainer';
import EditOrderContainer from '../Containers/EditOrderContainer';
import OrderDetailsContainer from '../Containers/OrderDetailsContainer';

import EditUserContainer from '../Containers/EditUserContainer';

import SweepFormContainer from '../Containers/SweepFormContainer';

const TabsContainer: React.FC = (props: any) => {
  const { user } = props;

  props.onGetOrders(user.email);
  props.onGetItems(user.email);

  return (
    <IonPage>
      <IonButtons slot="start" style={{ position: 'fixed', top: 10, left: 10 }}>
        <IonMenuButton />
      </IonButtons>
      <IonReactRouter>
        <IonTabs>
          <IonRouterOutlet>
            <Route path="/dashboard" component={Tab0} exact={true} />
            <Route path="/orders" component={Tab1} exact={true} />
            <Route path="/inventory" component={Tab2} exact={true} />
            <Route path="/profile" component={Tab3} exact={true} />

            <Route path="/addItem" component={AddItemContainer} exact />
            <Route path="/item/:id" component={ItemDetailsContainer} exact />
            <Route path="/editItem/:id" component={EditItemContainer} exact />

            <Route path="/addOrder" component={AddOrderContainer} exact />
            <Route path="/order/:id" component={OrderDetailsContainer} exact />
            <Route path="/editOrder/:id" component={EditOrderContainer} exact />

            <Route path="/editUser" component={EditUserContainer} exact />

            <Route path="/sweep" component={SweepFormContainer} exact />

            <Route path="/" render={() => <Redirect to="/orders" />} />
            <Route path="" render={() => <Redirect to="/orders" />} />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="dashboard" href="/dashboard">
              <IonIcon icon={gridOutline} />
              <IonLabel>Dashboard</IonLabel>
            </IonTabButton>
            <IonTabButton tab="orders" href="/orders">
              <IonIcon icon={documentTextOutline} />
              <IonLabel>Orders</IonLabel>
            </IonTabButton>
            <IonTabButton tab="inventory" href="/inventory">
              <IonIcon icon={fileTrayFullOutline} />
              <IonLabel>Inventory</IonLabel>
            </IonTabButton>
            <IonTabButton tab="profile" href="/profile">
              <IonIcon icon={personOutline} />
              <IonLabel>Profile</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
    userDBInfo: state.userReducer.userDbInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSetUser: (payload: {}) => dispatch(actionCreator.setUser(payload)),
    onGetOrders: (payload: any) =>
      dispatch(ordActionCreator.getOrders(payload)),
    onGetItems: (payload: any) => dispatch(invActionCreator.getItems(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TabsContainer);
